import { render, staticRenderFns } from "./current-request-top.vue?vue&type=template&id=4664f82a&"
import script from "./current-request-top.vue?vue&type=script&lang=js&"
export * from "./current-request-top.vue?vue&type=script&lang=js&"
import style0 from "./current-request-top.vue?vue&type=style&index=0&id=4664f82a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports